// Зашитый в UARM id "виртуального" дочернего АРМа "Группы доступа"
const GROUP_ACCESS_ARM_ID = 938189999;
// тест cypress\e2e\uarm-front\uarm-front_child-extra-columns.spec.js
import { cloneDeep } from 'lodash';

/**
 *
 * 			Оставь надежду всяк сюда входящий
 *
 */

export default {
	methods: {
		/**
		 * Переход к дочернему АРМу
		 * @param {object} opt опции
		 * @param {object} opt.childArmObj элемент массива childArms родителя, ребенок НА которого переходим
		 * @param {object} opt.parentRecordData данные родительской записи {<имязаписи>: значение value}
		 * @param {boolean} opt.isCard признак карточки
		 */
		childNav_toChild({ childArmObj, parentRecordData, isCard }) {
			const childPath = this.$data.childNav_pathArray.slice();
			const childArmId = childArmObj.armId;
			// метаданные родительского АРМ (ИЗ которого переходим)
			const parentArmMeta = this.$data.armMeta; /* parent-data! */

			const recordTitle = getCombinedRecordTitle(parentArmMeta, parentRecordData);

			if (childPath.length === 0) {
				// если открыт КОРНЕВОЙ АРМ
				childPath.push({
					armId: this.$data.armId,
					isCard: !!isCard, // переход был совершен из карточки
					armCaption: parentArmMeta.caption,
					currentRecordId: parentRecordData.ITEM_ID,
					parentRecordName: recordTitle,
				});
			}

			// если переходим в дочерний, пишем обновление в последнюю запись (последняя запись это текущий арм)
			if (childPath.length > 1) {
				childPath[childPath.length - 1].currentRecordId = parentRecordData.ITEM_ID;
				childPath[childPath.length - 1].isCard = !!isCard; // переход был совершен из карточки
				childPath[childPath.length - 1].parentRecordName = recordTitle;
			}

			// console.error(`!!!!!!!! УДАЛИТЬ !!!!!!!!!!! ТОЛЬКО ДЛЯ ЛОКАЛЬНОГО`);childArmObj.extraColumns = [{sourceColumn: 'sys_date_create',targetColumn: 'record_time',requestParamSuffix: '__MIN',},];

			// доп. колонки для фильтрации дочернего (CWP-20568)
			const parentExtraColumns = cloneDeep(childArmObj.extraColumns || []).map((excol) => {
				const sourceColumnValue = parentRecordData[excol.sourceColumn];

				return {
					sourceColumnValue,
					...excol,
				};
			});

			// Собственно добавляем в цепочку дочерний АРМ на который только что кликнули
			childPath.push({
				armId: childArmId,
				armCaption: childArmObj.childCaption || `Дочерний АРМ ${childArmId}`,
				parentRecordId: parentRecordData.ITEM_ID,
				targetColumn: childArmObj.targetColumn, // колонка для фильтрации,
				parentExtraColumns,
			});

			this.childNav_go(childPath, childArmId);
		},
		/** Собственно переход к дочернему АРМ */
		childNav_go(currentPaths, targetArmId) {
			//console.log(`childNav_go currentPaths =`, currentPaths);
			const query = {
				domain_id: this.$route.query.domain_id,
				pick_type: this.$route.query.pick_type,
				// здесь вся цепочка дочерних АРМ
				childPathParam: encodeURIComponent(JSON.stringify(currentPaths)),
				parentArmId: targetArmId === GROUP_ACCESS_ARM_ID ? this.armId : null, // ID родительского арма (PIRS-2-10938)
			};

			const lastPath = currentPaths[currentPaths.length - 1];

			this.$router.push({
				name: lastPath.isCard ? 'ArmView_Card' : 'ArmView_List',
				params: {
					armId: targetArmId,
					vpId: this.$route.params.vpId,
					specMode: this.$route.params.specMode, // все дети АРМ ServicePoint (specMode='sp') являются АРМами СП тоже. Если будут другие спецрежимы, надо будет вводить дифференциацию
					recordId: lastPath.isCard ? lastPath.currentRecordId : undefined,
				},
				query,
			});
		},
		/** Получение представления цепочки детей в истории */
		childNav_getPathArray() {
			const queryString = this.$route.query.childPathParam || '';
			let res = [];

			if (queryString) {
				const queryStringParsed = JSON.parse(decodeURIComponent(queryString));
				if (queryStringParsed.length !== 1) {
					// если не корневой родитель
					res = queryStringParsed;
				}
			}

			return res;
		},
		/** Получение основного поля (ПК), которое должно быть предзаполнено если текущий АРМ - дочерний */
		childNav_getParentFieldToSet() {
			const lastChildPath = this.$data.childNav_pathArray[this.$data.childNav_pathArray.length - 1] || {};

			return {
				name: lastChildPath.targetColumn,
				value: lastChildPath.parentRecordId,
			};
		},
		/** Получение доп. параметров фильтрации в дочернем АРМ (см. CWP-20568)
		 * @returns string;
		 */
		childNav_getExtraParamsToSet() {
			const lastChildPath = this.$data.childNav_pathArray[this.$data.childNav_pathArray.length - 1] || {};
			const params = lastChildPath.parentExtraColumns.reduce((acc, pexcol) => {
				const { requestParamSuffix, sourceColumnValue, targetColumn } = pexcol;
				acc.push(`${targetColumn}${requestParamSuffix}=${encodeURIComponent(sourceColumnValue)}`);

				return acc;
			}, []);

			return params.join('&');
		},
		/**
		 * Функционал отправки в юарм-сервер отдельного поля armState, которое попадает в АРМ Журнал (77700)
		 * @param {*} fields
		 * @param {*} recordData
		 */
		childNav_getArmState(fields, recordData) {
			const currentArmMeta = this.armMeta; // data и props
			const currentRecordName = getCombinedRecordTitle(currentArmMeta, recordData);
			let armPathText = '';
			const childNav_pathArray = this.childNav_getPathArray();
			//console.log('childNav_pathArray=', childNav_pathArray);
			if (childNav_pathArray.length) {
				// Это случай нахождения в дочернем АРМ
				armPathText = childNav_pathArray
					.map((ap, ind) => {
						const childWord = ind === 0 ? '' : 'Доч. ';
						const tab = '   '.repeat(ind);
						// АХТУНГ! сборка аналогичной строки в двух экземплярах в этом файле! Искать по слову АХТУНГ
						// имена АРМ тоже можно truncate
						let res = `${tab}${childWord}АРМ: ${ap.armCaption} (${ap.armId})`;
						const recordId = ap.currentRecordId || recordData.ITEM_ID;
						if (recordId) {
							res += `\n${tab}Запись: ${ap.parentRecordName || currentRecordName} (${recordId})`;
						}

						return res;
					})
					.join('\n');
			} else {
				// Это случай корневого АРМ
				// лучше бы может руками пихать что-то в childNav_pathArray, не знаю...
				// имена АРМ тоже можно truncate
				// АХТУНГ! сборка аналогичной строки в двух экземплярах в этом файле! Искать по слову АХТУНГ
				let res = `АРМ: ${currentArmMeta.caption} (${currentArmMeta.id})`;
				const recordId = recordData.ITEM_ID;
				if (recordId) {
					res += `\nЗапись: ${currentRecordName} (${recordId})`;
				}
				armPathText = res;
			}

			return {
				actionUrl: window.location.pathname + window.location.search + window.location.hash,
				armPathText,
			};
		},
	},
};

/**
 * Костыльное преобразование форматов, иначе надо будет извлекать форматированное значение из контрола. Поддерживаем строки, даты и колонки со справочниками
 * @param {object} parentRecordData
 * @param {*} recDataValue
 */
function getWorkaroundFormattedValue(parentRecordData, parColName) {
	if (parColName.includes('date')) {
		// опять-таки дата только со временем
		return new Date(parentRecordData[parColName])
			.toLocaleDateString('ru-RU', { hour: '2-digit', minute: '2-digit' })
			.replace(',', '');
	}
	// для колонок со справочником, там в value объект { id, name }
	else if (parentRecordData[parColName]?.name) {
		return parentRecordData[parColName]?.name;
	}

	return parentRecordData[parColName];
}

/**
 * Вычисление комбинированного заголовка родительской записи в хлебных крошках и в АРМ Журнал
 * Cначала ищем поля в свойстве метаданых АРМ recordTitleColumns,
 * Потом берём name, затем, если и его нет - берём "ID=XXX"
 * @param {import('src/types').UarmArm} armMeta
 */
function getCombinedRecordTitle(armMeta, recordData) {
	// console.log({ armMeta, recordData });
	let recordTitle;
	const { recordTitleColumns } = armMeta;
	if (recordTitleColumns?.length) {
		const recordTitleArr = recordTitleColumns.map((parColName) => {
			// здесь возможно придется дописать поддержку Object и Array
			let val = `—`;
			if (recordData[parColName] !== undefined && recordData[parColName] !== null) {
				val = getWorkaroundFormattedValue(recordData, parColName);
			}

			return val;
		});
		recordTitle = recordTitleArr.join(' ');
	} else {
		recordTitle = recordData.name || `ID=${recordData.ITEM_ID}`;
	}

	return truncate(recordTitle, 400);
}

/**
 * Return a truncated version of the given string, cut off at n characters.
 * If the string is longer than n characters, it is cut off at the last
 * space character before n characters and an ellipsis is appended.
 * @param {string} str
 * @param {number} n
 * @return {string}
 */
function truncate(str, n) {
	if (str.length <= n) {
		return str;
	}
	const subString = str.slice(0, n - 1); // the original check

	return `${subString.slice(0, subString.lastIndexOf(' '))}…`;
}
